import React, { useState, useEffect } from "react";
import dayjs from 'dayjs';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Grid from '@mui/material/Grid2';

import { TypographyNomal, TypographyNomalBold } from '../style/typography';
import { BoxFlexStart } from '../style/box';
import customParseFormat from 'dayjs/plugin/customParseFormat';

export default function InspectionPeriod({ checkSummary, updateCheckSummary, handleChange, isReadOnly }) {
    dayjs.extend(customParseFormat);
    const [startTime, setStartTime] = useState(() =>
        checkSummary?.start_time ? dayjs(checkSummary.start_time, "HH:mm") : null
    );
    const [endTime, setEndTime] = useState(() =>
        checkSummary?.end_time ? dayjs(checkSummary.end_time, "HH:mm") : null
    );
    const [startTimeError, setStartTimeError] = useState(null);
    const [endTimeError, setEndTimeError] = useState(null);

    const getErrorMessage = (error) => {
        switch (error) {
          case 'invalidDate':
            return '有効な時間形式で入力してください。';
          case 'required':
            return '必ず入力してください。';
          default:
            return '';
        }
    };

    useEffect(() => {
        if (!startTime) setStartTimeError("required");
        if (!endTime) setEndTimeError("required");
    }, [])

    useEffect(() => {
        const formattedStart = startTime ? startTime.format("HH:mm") : "";
        const formattedEnd = endTime ? endTime.format("HH:mm") : "";

        if (checkSummary.start_time !== formattedStart) {
            updateCheckSummary("start_time", formattedStart);
        }
        if (checkSummary.end_time !== formattedEnd) {
            updateCheckSummary("end_time", formattedEnd);
        }
    }, [startTime, endTime]);

    const handleStartTimeChange = (newValue) => {
        setStartTime(newValue);
        handleChange({ target: { value: newValue ? newValue.format("HH:mm") : "" } });
        // updateCheckSummary('start_time', newValue ? newValue.format("HH:mm") : "");

      
        if (!newValue) {
          setStartTimeError("required");
        } else {
          setStartTimeError(null);
        }
      };
      
    const handleEndTimeChange = (newValue) => {
    setEndTime(newValue);
    // updateCheckSummary('end_time', newValue ? newValue.format("HH:mm") : "");
    handleChange({ target: { value: newValue ? newValue.format("HH:mm") : "" } });
    
    if (!newValue) {
        setEndTimeError("required");
    } else {
        setEndTimeError(null);
    }
    };

    const handleTimeError = (reason, setter) => {
        if (reason === "invalidDate") {
            setter("invalidDate");
          }
    };

    return (
        <>
            <Grid container
                spacing={1}
                columns={12}
            >
                <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                    <TypographyNomalBold>
                        点検期間
                    </TypographyNomalBold>
                </Grid>
                <Grid size={{ xs: 12, sm: 8, md: 9 }}>
                    <BoxFlexStart>
                        {isReadOnly ? (
                            checkSummary?.start_time ? dayjs(checkSummary.start_time, "HH:mm").format("HH:mm") : "-"
                        ) : (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label="点検開始時間"
                                    ampm={false}
                                    value={startTime}
                                    onChange={handleStartTimeChange}
                                    onError={(reason) => handleTimeError(reason, setStartTimeError)}
                                    slotProps={{
                                        textField: {
                                            error: !!startTimeError,
                                            helperText: getErrorMessage(startTimeError),
                                            margin: "dense",
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        )}
                        <TypographyNomal m={1}>~</TypographyNomal>
                        {isReadOnly ? (
                            checkSummary?.end_time ? dayjs(checkSummary.end_time, "HH:mm").format("HH:mm") : "-"
                        ) : (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label="点検終了時間"
                                    ampm={false}
                                    value={endTime}
                                    onChange={handleEndTimeChange}
                                    onError={(reason) => handleTimeError(reason, setEndTimeError)}
                                    slotProps={{
                                        textField: {
                                            error: !!endTimeError,
                                            helperText: getErrorMessage(endTimeError),
                                            margin: "dense",
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        )}
                    </BoxFlexStart>
                </Grid>
            </Grid>

        </>
    );
}
